import { render, staticRenderFns } from "./StageViewNG.vue?vue&type=template&id=51cf1494"
import script from "./StageViewNG.vue?vue&type=script&lang=js"
export * from "./StageViewNG.vue?vue&type=script&lang=js"
import style0 from "./StageViewNG.vue?vue&type=style&index=0&id=51cf1494&prod&lang=scss"
import style1 from "./StageViewNG.vue?vue&type=style&index=1&id=51cf1494&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports